import styles from './index.less';
import { useEffect, useState } from 'react';
import NoData from '@/components/NoData';
import { detailWechatVote, resultWechatVote, submitWechatVote, viewWechatRespondents } from '@/service/banner';
import { Helmet, useLocation, useModel } from '@umijs/max';
import { history } from '@umijs/max';
import { Cell, Checkbox, Input, Loading, Radio, Toast } from 'react-vant';
import BottomButton from '../components/BottomButton';
import { InfoO } from '@react-vant/icons';
import dayjs from 'dayjs';

interface WechatVoteDataType {
  communityId?: string;
  communityName?: string;
  content?: string;
  createBy?: string;
  createTime?: string;
  publishTime?: string;
  sequenceNbr?: string;
  status?: string;
  title?: string;
  endTime?: string;
  updateBy?: string;
  updateTime?: string;
  viewCount?: number;
  result?: string;
  disabled?: boolean;
  questions?: Array<any>;
}
const VoteDetail = () => {
  console.log(666, useLocation());
  const location = useLocation();
  const { ownerInformation } = useModel(
    'useDefaultRoom',
    (model) => ({
      ownerInformation: model.ownerInformation
    }),
  );

  console.log('ownerInformation>>>', ownerInformation)
  const data = new URLSearchParams(location.search).get('sequenceNbr');

  const formatStatus = (item: any) => {
    if (item.response === '1') {
      return '已提交';
    } else if (item.endFlag === '1' ) {
      return '已结束';
    } else {
      const startTime = dayjs(item.startTime);
      const endTime = dayjs(item.endTime);
      const currentTime = dayjs();
      const isAfterCurrentTime = currentTime.isAfter(endTime);
      const isBeforeCurrentTime = currentTime.isBefore(startTime);
      if (isBeforeCurrentTime) {
        return '未开始';
      }

      if (isAfterCurrentTime) {
        return '已结束';
      }

      if (!isAfterCurrentTime && !isBeforeCurrentTime) {
        return '进行中';
      }
    }
  };
  const [WechatVoteData, setWechatVoteData] = useState<WechatVoteDataType>({});
  const [Loading, setLoading] = useState<any>(false);
  const [isHasAnswered, setisHasAnswered] = useState<any>(false);
  useEffect(() => {
    detailWechatVote(data).then((res) => {
      console.log(res);
      if (res && res.code === 200 && res.data) {
        const dataVote = res.data
        const status = formatStatus(dataVote);
        // const detailsListData = res.data.questions || []
        resultWechatVote({voteId: data, ownerId: ownerInformation?.sequenceNbr,}).then((res) => {
          console.log(res, Boolean(res.data))
          if (res && res.code === 200) {
            if (!res.data) {
              setisHasAnswered(false)
              
              if (status === '已结束' || status === '未开始' ) {
                setisHasAnswered(true)
              }
            } else {
              setWechatVoteData({...dataVote, result:res.data.result});
              setisHasAnswered(true)
              return
            }
          } else {
            setisHasAnswered(false)
          }
        })
        setWechatVoteData(res.data);
        
      } else {
        setWechatVoteData({});
      }
    });
    
  }, [data]);

  const optionList = [
    { 
      key: 1,
      label: '赞成',
      value: 'agree'
    },
    { 
      key: 2,
      label: '反对',
      value: 'refuse'
    },
    { 
      key: 3,
      label: '弃权',
      value: 'abstain'
    },
  ]

  // const formatTime = (time: any) => {
  //   return time ? dayjs(time).format('YYYY-MM-DD') : '-';
  // };
  const handleAnswerChange = (value: any) => {
    setWechatVoteData({...WechatVoteData, result: value})
  };


  
  const submit = () => {
    console.log(WechatVoteData.result)
    if (!WechatVoteData.result) {
      Toast('请完整的答题!')
      return
    }

    
    let params = {
      openId:  ownerInformation?.openId,
      ownerId: ownerInformation?.sequenceNbr,
      ownerName: ownerInformation?.nickName,
      phonenumber: ownerInformation?.phonenumber,
      voteId: WechatVoteData.sequenceNbr,
      result:  WechatVoteData.result,
    }
    
    setLoading(true)
    submitWechatVote(params).then(res => {
      if (res && res.code === 200) {
        Toast.success('提交成功!')
        history.back()
      }
    }).finally(() => {
      setLoading(false)
    })
  
  }

  return (
    <div className={styles['voteDetail']}>
      <Helmet>
        <title>投票详情</title>
      </Helmet>
      <div>
        {Object.entries(WechatVoteData).length ? (
          <>
            <div className={styles['newsDatailsBox']}>
              <div className={styles['headContainer']}>
                <div className={styles['title']}>{WechatVoteData.title}</div>
                <div className={styles['tip']}><InfoO  />为了保证调查的公平公正，请认真填写真实信息</div>
                <div className={styles['tip']}>投票截止时间: {WechatVoteData.endTime}</div>
              </div>
              <div className={styles.quetionContaner}>
                    <div >
                      <div className={styles['name']}>
                       <div className={styles['nameText']}>第1题：{WechatVoteData.content}</div>
                       <div className={styles['nameType']}>单选</div>
                      </div>
                      <div className={styles['cellContainer']}>
                          <Cell.Group  card>
                            <div className={styles['cellGroup']} >
                            <Radio.Group  
                              value={WechatVoteData.result} 
                              onChange={(e) =>handleAnswerChange(e)}
                              direction="vertical"
                              disabled= {isHasAnswered}
                            >
                              {optionList?.map((option: any, i: number) => (
                                <Radio key={i} name={option.value} className={styles['selectBox']}>
                                  {option.label}
                                </Radio>
                              ))}
                            </Radio.Group>
                            </div>
                          </Cell.Group>
                      </div>
                    </div>
                  </div>
              {!isHasAnswered && (
                <div>
                  <BottomButton loading={Loading} text={'提交'} click={() => submit()}></BottomButton>
                </div>
              )}
            </div>
          </>
        ) : (
          <NoData />
        )}
      </div>
    </div>
  );
};

export default VoteDetail;
